import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useLocalStorage } from '@uidotdev/usehooks'

interface Props {
  isMobile: boolean
  isEditing: boolean
}

const MobileSwipeHelp: React.FC<Props> = ({ isMobile, isEditing }) => {
  const [swipeHelpShown, setSwipeHelpShown] = useLocalStorage<boolean>('fantahockey:swipeHelpShown', false)

  if (!isMobile || isEditing || swipeHelpShown) return null

  return (
    <Box
      onClick={() => { setSwipeHelpShown(true) }}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100dvw',
        height: '100dvh',
        bgcolor: 'rgba(0,0,0,0.7)',
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 0,
        textAlign: 'center',
        color: 'white'
      }}
      role="button"
      aria-label="Swipe help overlay, tap to dismiss"
    >
      <Box sx={{ maxWidth: 420 }}>
        <Typography variant="h6" gutterBottom>Swipe to navigate</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Swipe left or right to browse the cards.
        </Typography>
        <Button variant="contained" onClick={(e) => { e.stopPropagation(); setSwipeHelpShown(true) }}>
          Got it
        </Button>
      </Box>
    </Box>
  )
}

export default React.memo(MobileSwipeHelp)
